const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost', '::1']);

const trimTrailingSlash = (value = '') => String(value || '').trim().replace(/\/$/, '');

const isBrowserLoopback = () => {
  if (typeof window === 'undefined') return false;
  return LOOPBACK_HOSTS.has(window.location.hostname);
};

export const resolveRuntimeUrl = (configuredUrl = '', { sameOriginFallback = true } = {}) => {
  const configured = trimTrailingSlash(configuredUrl);
  if (!configured) {
    return sameOriginFallback && typeof window !== 'undefined'
      ? trimTrailingSlash(window.location.origin)
      : '';
  }

  try {
    const parsed = new URL(configured, typeof window !== 'undefined' ? window.location.origin : undefined);
    if (LOOPBACK_HOSTS.has(parsed.hostname) && !isBrowserLoopback()) {
      return sameOriginFallback && typeof window !== 'undefined'
        ? trimTrailingSlash(window.location.origin)
        : '';
    }
  } catch {
    return configured;
  }

  return configured;
};

export const resolveApiBaseUrl = () => resolveRuntimeUrl(process.env.REACT_APP_BACKEND_URL, {
  sameOriginFallback: true,
});

export const resolveChatBaseUrl = () => {
  const configured = resolveRuntimeUrl(process.env.REACT_APP_CHAT_URL, {
    sameOriginFallback: false,
  });
  if (/\/\/chat\.playemp\.vip$/i.test(configured)) return '';
  return configured;
};
